import styled from "styled-components";
import { breakpoints } from "styles";

export const AccordionTitleWrapper = styled.div<{ isBordered: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ isBordered }) => (isBordered ? "16px" : "16px 0")};
  @media ${breakpoints.tablet} {
    padding: ${({ isBordered }) => (isBordered ? "20px 24px" : "16px 0")};
  }
`;

export const AccordionContent = styled.div<{
  isCollapse: boolean;
  isBordered: boolean;
}>`
  transition: all 0.3s;
  max-height: ${({ isCollapse }) => (isCollapse ? "1000px" : "0")};
  overflow-y: auto;
  margin: ${({ isCollapse, isBordered }) =>
    isCollapse && isBordered ? "8px 0" : "0"};
  padding: ${({ isCollapse, isBordered }) =>
    isCollapse && isBordered
      ? "0 16px 16px"
      : isCollapse && isBordered
      ? "0 0 8px 0"
      : "0"};

  @media ${breakpoints.tablet} {
    padding: ${({ isCollapse, isBordered }) =>
      isCollapse && isBordered
        ? "0 24px 16px"
        : isCollapse && !isBordered
        ? "0 0 8px 0"
        : "0"};
  }
`;

export const AccordionTitle = styled.p<{ isCollapse: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  font-weight: 700;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ isCollapse, theme }) =>
    isCollapse ? theme.colors.brand["500"] : theme.colors.neutral["900"]};
  margin: 0;
  display: flex;
  gap: 4px;
  align-items: center;
  transition: all 0.3s;
  line-height: 0px;

  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

export const AccordionSubTitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin: 4px 0 0 0;
`;

export const AccordionItem = styled.div<{
  isDisabled: boolean;
  isBordered: boolean;
}>`
  border-bottom: ${({ theme, isDisabled }) =>
    !isDisabled && `1px solid ${theme.colors.periwinkle[500]}`};
  border: ${({ theme, isBordered }) =>
    isBordered ? `2px solid ${theme.colors.brand[500]}` : ""};
  border-radius: ${({ isBordered }) => (isBordered ? "6px" : "")};
  cursor: pointer;
`;

export const ChevronWrapper = styled.div<{ isCollapse: boolean }>`
  transition: all 0.3s;
  transform: ${({ isCollapse }) =>
    isCollapse ? "rotate(90deg)" : "rotate(-90deg)"};
  display: flex;
`;
